/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReplitCatalogPage } from '../models/ReplitCatalogPage';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReplitCatalogService {

    /**
     * List Replit Catalog Apps
     * List active apps from the most recently published mirror snapshot.
     * @param limit
     * @param cursor
     * @returns ReplitCatalogPage Successful Response
     * @throws ApiError
     */
    public static listReplitCatalogAppsApiV1ReplitCatalogAppsGet(
        limit: number = 50,
        cursor?: (string | null),
    ): CancelablePromise<ReplitCatalogPage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/replit-catalog/apps',
            query: {
                'limit': limit,
                'cursor': cursor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List My Replit Catalog Apps
     * List active apps exactly owned by the authenticated CompanyOS user.
     * @param limit
     * @param cursor
     * @returns ReplitCatalogPage Successful Response
     * @throws ApiError
     */
    public static listMyReplitCatalogAppsApiV1ReplitCatalogMyAppsGet(
        limit: number = 50,
        cursor?: (string | null),
    ): CancelablePromise<ReplitCatalogPage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/replit-catalog/my-apps',
            query: {
                'limit': limit,
                'cursor': cursor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
